import * as Sentry from '@sentry/browser'
import { objectToFormData } from 'object-to-formdata'
import { getModuleName } from './token'

const options = {
  indices: true,
}

export function getStore() {
  const module = getModuleName()

  // ESMは条件付きインポートを対応していないのでrequire()を使用
  /* eslint-disable global-require */
  if (module === 'admin') {
    return require('../admin/store').default
  }

  if (module === 'client') {
    return require('../client/store').default
  }
  /* eslint-disable global-require */

  return null
}

export function incrementLoadingCount(config) {
  const store = getStore()
  // オートコンプリートのリクエストはローディングカウントを無視。
  if (!config.headers['X-CMAP-No-Loading']) {
    store.commit('incrementLoadingCount')
  }

  return config
}

export function decrementLoadingCount(callback) {
  const store = getStore()
  const { config } = callback
  if (!config || config.headers['X-CMAP-No-Loading']) {
    return callback
  }
  setTimeout(() => {
    store.commit('decrementLoadingCount')
  }, 100)

  return callback
}

export function resetLoadingCount(callback) {
  const store = getStore()
  if (store.state.ignoreResetLoading) {
    return callback
  }
  setTimeout(() => {
    store.commit('clearLoadingCount')
  }, 200)

  return callback
}

export function handleUnAuthorized(error) {
  if (error.response && error.response.status === 401) {
    resetLoadingCount()
    window.replace = `/${getModuleName()}/`
  }

  return Promise.reject(error)
}

export function handleForbidden(error) {
  if (error.response && error.response.status === 403) {
    resetLoadingCount()
    getStore().commit(
      'setSystemMessage',
      { message: 'アクセス権限がありません。' },
    )
  }

  return Promise.reject(error)
}

export function handleNotFound(error) {
  if (error.response && error.response.status === 404) {
    resetLoadingCount()
    getStore().commit(
      'setSystemMessage',
      { message: error.response.data.message ? error.response.data.message : 'URLが見つかりません。' },
    )
  }

  return Promise.reject(error)
}

export function handleTooManyRequests(error) {
  if (error.response && error.response.status === 429) {
    resetLoadingCount()
    getStore().commit(
      'setSystemMessage',
      {
        message: 'ただいま混み合っています。しばらく経ってからアクセスしてください。',
        global: true,
      },
    )
  }

  return Promise.reject(error)
}

export function handleValidationError(error) {
  if (error.response && error.response.status === 422) {
    resetLoadingCount()
    const { errors } = error.response.data
    getStore().commit(
      'setSystemMessage',
      {
        message: Object.values(errors).map(function join(message) {
          return Array.isArray(message) ? message.map(join).join('\n') : message
        }).join('\n'),
        color: 'warning',
        light: true,
      },
    )
  }

  return Promise.reject(error)
}

export function handleServerError(error) {
  if (error.response && error.response.status === 500) {
    resetLoadingCount()
    getStore().commit(
      'setSystemMessage',
      { message: 'システムエラーが発生しました。' },
    )
    Sentry.captureException(error)
  }

  return Promise.reject(error)
}

export function handleAnyErrors(error) {
  if (error.response && error.response.status >= 400 && error.response.status !== 422) {
    Sentry.setTag('logic', 'axios')
    Sentry.captureException(error)
  }

  return Promise.reject(error)
}

export const toFormData = (data) => {
  const sanitizedData = data

  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key]) && data[key].length === 0) {
      delete sanitizedData[key]
    }
  })

  return objectToFormData(sanitizedData, options)
}

export default toFormData
